import { render, staticRenderFns } from "./NetajetReports.vue?vue&type=template&id=6c506b45&scoped=true&"
import script from "./NetajetReports.vue?vue&type=script&lang=js&"
export * from "./NetajetReports.vue?vue&type=script&lang=js&"
import style0 from "./NetajetReports.vue?vue&type=style&index=0&id=6c506b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c506b45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/abimelec/repositories/nxtagro_op_front/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataTable,VDialog,VFlex,VForm,VIcon,VLayout,VSelect,VSpacer,VTextField,VToolbar,VToolbarTitle})
